var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.loading } },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          staticStyle: { margin: "12px 70px 0 70px" },
          attrs: {
            model: _vm.pageData,
            rules: _vm.rules,
            "label-col": { span: 3 },
            "wrapper-col": { span: 14 },
            labelAlign: "left"
          }
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "复核类型", prop: "type" } },
            [
              _c(
                "a-radio-group",
                {
                  attrs: { disabled: _vm.readonly },
                  model: {
                    value: _vm.pageData.type,
                    callback: function($$v) {
                      _vm.$set(_vm.pageData, "type", $$v)
                    },
                    expression: "pageData.type"
                  }
                },
                _vm._l(_vm.typeOptions, function(item) {
                  return _c(
                    "a-radio",
                    {
                      key: item.value,
                      staticStyle: { "margin-right": "24px" },
                      attrs: { value: item.value, name: "roleCode" }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(item.name) + "\n\n          "
                      ),
                      _c(
                        "a-tooltip",
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.remark) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("a-icon", {
                            staticStyle: {
                              "margin-left": "8px",
                              color: "#999"
                            },
                            attrs: { type: "exclamation-circle" }
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.pageData.type == "2"
            ? _c("a-form-model-item", [
                _c("div", { staticClass: "text-color-orange text-tip" }, [
                  _vm._v(
                    "\n        达到一定金额开立祺信复核方可流转到该级，复核以最后一级操作为准"
                  ),
                  _c("br"),
                  _vm._v(
                    "变更复核类型会影响当前数据，请确认无复核数据后再进行操作。\n      "
                  )
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "is-rev-table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "width-1" }, [_vm._v("复核员")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("祺信开立金额")]),
                      _vm._v(" "),
                      _c(
                        "th",
                        [
                          !_vm.readonly
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "link" },
                                  on: { click: _vm.addLevel }
                                },
                                [_vm._v("新增")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.levelList, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { staticClass: "width-1" }, [
                          _vm._v(_vm._s(index + 1) + " 级")
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "2" } }, [
                          _c(
                            "div",
                            { staticClass: "spaceLeft" },
                            [
                              _c("a-input", {
                                staticStyle: { width: "210px" },
                                attrs: {
                                  disabled: index == 0 || _vm.readonly,
                                  suffix: "元",
                                  placeholder: "请输入金额",
                                  type: "number"
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.checkAmount(item.amount, index)
                                  }
                                },
                                model: {
                                  value: item.amount,
                                  callback: function($$v) {
                                    _vm.$set(item, "amount", _vm._n($$v))
                                  },
                                  expression: "item.amount"
                                }
                              }),
                              _vm._v(" "),
                              index > 1 && !_vm.readonly
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "text-color-orange",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeLevel(index)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-400efd1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-400efd1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/character/issue-review-modal.vue
// module id = uNH/
// module chunks = 1